const Grid6 = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-grid6"
      xmlns="http://www.w3.org/2000/svg"
      data-name="icon-grid6"
      viewBox="0 0 24 24"
      width={_width}
      {...props}
    >
      <path
        d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
        stroke="#292D32"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10 2V22"
        stroke="#292D32"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10 8.5H22"
        stroke="#292D32"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10 15.5H22"
        stroke="#292D32"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default Grid6;
